"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {}
};

/**
 * Single decorated radio button wrapper
 * <br><i>Warning: This component will be deprecated in a future version of anypoint-components</i>
 */
var Radio = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Radio, _React$Component);
  function Radio(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Radio);
    _this = _callSuper(this, Radio, [props]);
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Radio, [{
    key: "onChange",
    value: function onChange(e) {
      if (!e.target.checked) {
        return;
      }
      this.check();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (e.key === ' ') {
        // space bar
        e.preventDefault();
        this.check();
      }
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        theme = _this$props.theme;
      return (0, _classnames["default"])('radio-button', theme.Radio, className, (0, _defineProperty2["default"])({}, theme.disabled, disabled));
    }

    /**
     * Triggers onChange handler if currently radio button is not disabled and not checked.
     * If there is a bunch of Radio components with the same name, only the checked one will trigger change
     * and other radios states should be controlled by outer component, e.g. RadioGroup
     */
  }, {
    key: "check",
    value: function check() {
      var _this$props2 = this.props,
        value = _this$props2.value,
        checked = _this$props2.checked,
        disabled = _this$props2.disabled,
        onChange = _this$props2.onChange;
      if (disabled || checked || !onChange) {
        return;
      }
      onChange(value);
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props3 = this.props,
        label = _this$props3.label,
        testId = _this$props3.testId,
        theme = _this$props3.theme;
      if (!label) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.label,
        "data-test-id": testId && "".concat(testId, "-label")
      }, label);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        id = _this$props4.id,
        name = _this$props4.name,
        value = _this$props4.value,
        style = _this$props4.style,
        checked = _this$props4.checked,
        disabled = _this$props4.disabled,
        testId = _this$props4.testId,
        theme = _this$props4.theme,
        labelRef = _this$props4.labelRef,
        ariaLabel = _this$props4['aria-label'],
        ariaLabelledBy = _this$props4['aria-labelledby'],
        ariaDescribedBy = _this$props4['aria-describedby'];
      return /*#__PURE__*/_react["default"].createElement("label", {
        style: style,
        className: this.getClassNames(),
        htmlFor: id,
        tabIndex: disabled ? '-1' : '0',
        onKeyDown: this.onKeyDown,
        "data-test-id": testId,
        "data-anypoint-component": Radio.displayName,
        role: 'radio',
        "aria-checked": checked,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        ref: function ref(node) {
          if (labelRef && typeof labelRef === 'function') {
            labelRef(node);
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        className: theme.input,
        checked: checked,
        disabled: disabled,
        "data-test-id": testId && "".concat(testId, "-input"),
        onChange: this.onChange
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.overlay
      }), this.renderLabel());
    }
  }]);
  return Radio;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Radio, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Radio, "displayName", 'Radio');
//# sourceMappingURL=Radio.js.map